// extracted by mini-css-extract-plugin
export default {"heading":"HeadingDep_heading__3JeCW"};